var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"view-send-activation-link d-flex justify-content-center align-items-center"},[_c('Envelope',{attrs:{"configurations":_vm.EnvelopeConfigurations}}),_c('SendActivationLinkAround')],1)}
var staticRenderFns = []

export { render, staticRenderFns }